export default "__VITE_ASSET__r2$iS8ed__"